import { Grid } from '@mui/material'


export default function Curva () {
    return (
        <>
            <Grid className='background-curva'>

            </Grid>
        </>
    )
}
